import React, { useState } from 'react';
import DatabaseManager from './DatabaseManager';
import PromptManager from './PromptManager';
import KeyManager from './KeyManager';
import ModelSwitcher from './ModelSwitcher';
import RagStatusTab from './RagStatusTab';
import ImageReviewPanel from './ImageReviewPanel';

const AdminPanel = () => {
    const [subTab, setSubTab] = useState('knowledge');

    const tabs = [
        { id: 'knowledge', label: 'Knowledge Base (Vector)' },
        { id: 'review', label: 'Image Review' },
        { id: 'prompts', label: 'AI Instructions (Brain)' },
        { id: 'models', label: 'Models & Config' },
        { id: 'keys', label: 'API Keys' },
        { id: 'database', label: 'SQL Database' },
    ];

    return (
        <div className="h-full flex flex-col bg-[var(--color-bg-content)]">
            {/* Sub-Header */}
            <div className="flex border-b border-stone-800 px-6 py-2 gap-4">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => setSubTab(tab.id)}
                        className={`px-4 py-2 text-sm font-medium rounded-t-lg border-b-2 transition-colors ${subTab === tab.id
                            ? 'text-white border-blue-500 bg-white/5'
                            : 'text-stone-500 border-transparent hover:text-stone-300'
                            }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Content */}
            <div className="flex-1 p-6 overflow-hidden overflow-y-auto">
                {subTab === 'database' && <DatabaseManager />}
                {subTab === 'knowledge' && <RagStatusTab />}
                {subTab === 'review' && <ImageReviewPanel />}
                {subTab === 'prompts' && <PromptManager />}
                {subTab === 'keys' && <KeyManager />}
                {subTab === 'models' && <ModelSwitcher />}
            </div>
        </div>
    );
};

export default AdminPanel;

